const HistoryIcon = () => {
    return (
        <svg
            id="Group_8102"
            data-name="Group 8102"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
            <g id="Group_7947" data-name="Group 7947">
                <circle
                    id="Ellipse_55"
                    data-name="Ellipse 55"
                    cx="9.412"
                    cy="9.412"
                    r="9.412"
                    transform="translate(0.588 0.588)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeWidth="0.75"
                />
                <line
                    id="Line_211"
                    data-name="Line 211"
                    y2="7.727"
                    transform="translate(10 2.272)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
                <line
                    id="Line_212"
                    data-name="Line 212"
                    x1="7.518"
                    y1="1.561"
                    transform="translate(10 10.001)"
                    fill="none"
                    stroke="var(--icon-color)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
            </g>
        </svg>
    );
};

export default HistoryIcon;
